import { Box } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import React, { ReactNode } from 'react';

import Heading, { HeadingSize } from '../Heading';

export type LabelFormatter = (value: number, max: number) => ReactNode;

export interface ProgressProps {
  color?: 'primary' | 'secondary';
  detail?: boolean;
  endSpacing?: boolean;
  formatLabel?: LabelFormatter;
  height?: string;
  max: number;
  maxWidth?: string;
  min: number;
  progressLabel?: boolean;
  value: number;
}

// eslint-disable-next-line react/display-name
const progressFormatter = () => (value: number, max: number) => (
  <Box
    sx={{
      float: 'right',
    }}
  >
    <Heading size={HeadingSize.LG}>
      <Box
        sx={{
          display: 'inline-block',
        }}
      >
        {value}
      </Box>
      /
      <Box
        sx={{
          display: 'inline-block',
        }}
      >
        {max}
      </Box>
    </Heading>
  </Box>
);

const Progress = ({
  color,
  detail,
  endSpacing,
  formatLabel,
  height,
  max,
  maxWidth,
  min,
  progressLabel,
  value,
}: ProgressProps): JSX.Element => {
  const formatter = progressLabel ? progressFormatter() : formatLabel;

  return (
    <Box
      sx={{
        ...(detail && {
          display: 'inline-block',
          width: '3em',
        }),
        ...(endSpacing && {
          marginBottom: '1em',
        }),
        '& .MuiLinearProgress-root': {
          borderRadius: '10px',
        },
      }}
    >
      <LinearProgress
        color={color}
        sx={{
          height,
          maxWidth,
        }}
        value={100 * ((Math.min(value, max) - min) / (max - min))}
        variant="determinate"
      />
      {formatter && formatter(value, max)}
    </Box>
  );
};

export default Progress;
